import React, { FC, useMemo } from 'react';
import ReactDOM from 'react-dom/client';

import r2wc from 'react-to-webcomponent';

import { VideoRecordPlaybackType } from '@distribute/shared/api-types/video-record';

import { Player } from '@distribute/frontend/ui/player';

import {
  DEFAULT_RATIO,
  getMuxImage,
  getMuxStream,
} from '@distribute/shared/utils';

type Props = {
  playbackId?: string;
  aspectRatio?: string;
  name: string;
  // Deprecated
  data: VideoRecordPlaybackType | null;
};

const VideoRecord: FC<Props> = ({ playbackId, aspectRatio, data, name }) => {
  const options = useMemo(() => {
    try {
      if (playbackId) {
        return {
          url: getMuxStream(playbackId),
          posterUrl: getMuxImage(playbackId),
          aspectRatio: aspectRatio || DEFAULT_RATIO,
          name: name,
        };
      }
      // Deprecated
      if (data) {
        return {
          url: getMuxStream(data.playbackId || ''),
          posterUrl: getMuxImage(data.playbackId || ''),
          aspectRatio: data.aspectRatio,
          name: data.name,
        };
      }

      return { url: '', posterUrl: '', aspectRatio: DEFAULT_RATIO, name: '' };
    } catch {
      return { url: '', posterUrl: '', aspectRatio: DEFAULT_RATIO, name: '' };
    }

    //eslint-disable-next-line
  }, []);

  const error = useMemo(() => {
    if (playbackId) return false;
    if (data) return false;
    return true;
    //eslint-disable-next-line
  }, []);

  return <Player error={error} {...options} />;
};

customElements.define(
  'video-record',
  r2wc(VideoRecord, React, ReactDOM, {
    props: {
      playbackId: 'string',
      aspectRatio: 'string',
      data: 'json',
      name: 'string',
    },
  })
);
